import { type IMapGeoObject } from '@cian/frontend-newbuilding-map-component';

import { type IResidentialComplex } from 'shared/types/residentials';

import { getGeoObject } from './getGeoObject';

export function getPins(complexes: IResidentialComplex[]): IMapGeoObject[] {
  return complexes.reduce((acc, curr) => {
    const pin = getGeoObject({
      coordinates: curr.coordinates,
      id: String(curr.id),
      markAsPlus: curr.displayType === 'plus',
      name: String(curr.id),
    });

    if (!pin) {
      return acc;
    }

    return [...acc, pin];
  }, Array.of<IMapGeoObject>());
}
